import React, {useRef} from "react";
import {DragPreviewImage, useDrag, useDrop} from "react-dnd";

export const ItemTypes = {
  CARD: 'card'
};

const style = {
  // border: '1px dashed gray',
  // padding: '0.5rem 1rem',
  // marginBottom: '.5rem',
  // backgroundColor: 'white',
  cursor: 'move'
};
export const SortableCard = ({id, text, index, moveCard}) => {
  const ref = useRef(null);
  const [{handlerId}, drop] = useDrop({
    accept: ItemTypes.CARD,
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId()
      };
    },
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      // Get vertical middle
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      // Time to actually perform the action
      moveCard(dragIndex, hoverIndex);
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex;
    }
  });
  const [{isDragging}, drag, preview] = useDrag({
    type: ItemTypes.CARD,
    item: () => {
      return {id, index};
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging()
    })
  });
  const opacity = isDragging ? 0.4 : 1;
  const draggedStyle = isDragging ? {
    border: '1px dashed gray',
    padding: '0.5rem 1rem',
    marginBottom: '.5rem',
    // backgroundColor: 'white',
    cursor: 'move'
  } : {};
  drag(drop(ref));
  return (
    <>
      <DragPreviewImage connect={preview} src={boxImage}/>
      <div ref={ref} style={{...style, opacity, ...draggedStyle}} data-handler-id={handlerId}>
        {text}
      </div>
    </>);
};

export const boxImage =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAA/CAYAAABXXxDfAAAACXBIWXMAAAsTAAALEwEAmpwYAAADqklEQVRoge2bTUhUURTHf35nZSUVlKa2KAnJgj4hKaWNfRC0DIQW0SIIIqJNEEUE4aI2uQlaBH1uotooLiJyYa0yKK1FLSzTCBK0JPAjX4vjcxx9M/PO+O69Q+MPDsLMPff9//PevDn3vCu44zRwyeHxnVELeFPR5FiLVUqBIWLmPeCQS0E26SHeuB97XIqyQRvBxj1gAqhxJ80sLSQ27scwUO5KoCnOkNq4H9+AZW5kRs9Bwhv3owfIcSE2SjaiN+7HCwd6I6MUGCR98x7wzLboqOhmfsb9eGBb+Hx5TjTG/bhtV3565AP3ida4Hy1AXpRio76jFgCHgR/A5NRrk0Al8Fgxz1HgOzF9+cAqoBUphiLB1s9JITCqGG9FV66NgyBnXkOVERWzsGU+I1kwn60smFdygczrvOwALpo+yFWk4DigzNuArqDR3u2rp/LuKPNCc52YuG3KXNPm18zIvavMTckt4sXtUuabNl+OVH5+/hNlfkLuBYirVs6xMmCOZKHt5BQTb94D2kmxFshP8l4OsjrbH/BeGVJ7h2WdYixABfBVMb4s4LVG4A1Qj/QG55Cohl4KdJD4u/0H+KsQlwssUYwfQc5eWHIQzUH0AvuAvjATrQU+YWZZ6ioGgc2pjG9ClqOuxZqIUaAukfHdyOXsWqTpmFOgNWaAKJsx/XD0XAaIcRHNucBispNp343AGO7Phq04NvuTqEEKC9fCTMZP5MYeyHLgVQaINBFvkRomJY8yQGyU8TTIZLIW8TWkcRHECeA94ZohHlLathL+5loH9IccC7Kk7SR4IXMDOK+Ya5qTBH+S6WwgGEowV1AsUs6dx9xVnQecSkNnHPXA+KxJtev5EuBXgLhEUaWcf/Z6fgxoSJUU5rLtALYSv8T0lOJMM0nsK/wF0fsyVVLYBuYHYAuyPobkfQAXFCJeupA9fh/DJGm6t8NIl7SN4OaBS1YjzcvtwG/TB1uhHG/6O1+kHA+k/9BiKM08U2ieAE+z8MQmW8lq8zYZJvwNr9iGIBO/1xVIT98vhDzkIYRmq0ktUlT5V2YeUr93oWuZW6cZqbj6kX20fcAAIjrsmZ9AStTxGXk3iXg3lglKgM9EuyRtt+pgnhQgZzzrjPtUIsXHfIx3WlcdITtJ3/g7B3ojpwm98QH+o384uEJ44yPoNy1mPA8JZ77WlUDTvCa58b3upJmnCCl+gowfcajLGuuZW+0ddynINg3EjJ91JcJVrdw79bcbuOxIA/8Adebg6sG0NtsAAAAASUVORK5CYII=';
